/** "3/22" → { taken: 3, ordered: 22 } */
export const parseTaken = (value) => {
  if (typeof value === "number") {
    return { taken: value, ordered: 0 };
  }
  const [taken, ordered] = String(value || "0/0").split("/");
  return { taken: parseInt(taken) || 0, ordered: parseInt(ordered) || 0 };
};

export const percentOf = (part, whole) =>
  whole > 0 ? Math.min(100, Math.round((part / whole) * 100)) : 0;
